<template>
  <div 
    id="public_access_water_ship"
    class="water_supplied"
  >
    <div 
      v-if="receivedData"
      class="public_access_water-item"
    >
      <TabsCustomGraphic
          :received-data="receivedData"
          :id="'public_access_water_ship-1'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
          :stacked="false"
      />
    </div> 
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'PublicAccessWater',
  
  components: {
    TabsCustomGraphic: () => import('@/components/graph/TabsCustomGraphic.vue'),
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'public_access_water',
      cloneElementId: 'public_access_water_ship'
    }
  },

  mounted() {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '72,73').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .public_access_water-item {
    margin-top: 20px;
  }
</style>